import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import { createCompany } from "../../network/api/company";
import DatePicker from "react-datepicker";

const AddCompanyPage = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    estableshedAt: "",
    address: "",
    commercialRegestration: "",
    taxNumber: "",
  });

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    createCompany(formData).then((result) => {
      if (result.data.message === "Created successfully") {
        toast.success(result.data.message, {
          position: "top-right",
        });
        props.changeToViewCompanies();
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
      setLoading(false);
    });
  };

  return (
    <div className="add-brokers-guideline">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="Name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter Name"
            required
            onInvalid={(e) => e.target.setCustomValidity("Name is required")}
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter Email"
            required
            onInvalid={(e) => e.target.setCustomValidity("Email is required")}
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="text"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Enter Password"
            required
            onInvalid={(e) =>
              e.target.setCustomValidity("Password is required")
            }
          />
        </div>

        <div className="form-group" style={{ marginTop: "20px" }}>
          <label htmlFor="estableshedAt">Established At</label>
          <DatePicker
            wrapperClassName="date-wrapper"
            className="date-input"
            selected={formData.estableshedAt}
            placeholderText="Select date"
            onChange={(date) =>
              setFormData((prev) => ({
                ...prev,
                estableshedAt: date,
              }))
            }
            dateFormat="yyyy-MM-dd"
          />
        </div>

        <div className="form-group">
          <label htmlFor="address">Address</label>
          <input
            type="text"
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Enter Address"
            required
            onInvalid={(e) => e.target.setCustomValidity("Address is required")}
          />
        </div>

        <div className="form-group">
          <label htmlFor="commercialRegestration">
            Commercial Registration
          </label>
          <input
            type="text"
            id="commercialRegestration"
            name="commercialRegestration"
            value={formData.commercialRegestration}
            onChange={handleChange}
            placeholder="Enter Commercial Registration"
            required
            onInvalid={(e) =>
              e.target.setCustomValidity("Commercial Registration is required")
            }
          />
        </div>

        <div className="form-group">
          <label htmlFor="taxNumber">Tax Number</label>
          <input
            type="text"
            id="taxNumber"
            name="taxNumber"
            value={formData.taxNumber}
            onChange={handleChange}
            placeholder="Enter Tax Number"
            required
            onInvalid={(e) =>
              e.target.setCustomValidity("Tax Number is required")
            }
          />
        </div>

        {loading ? (
          <div
            style={{
              width: "100%",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <div className="spinner"></div>
          </div>
        ) : (
          <button type="submit" className="submit-button">
            Add Company
          </button>
        )}
      </form>
      <ToastContainer />
    </div>
  );
};

export default AddCompanyPage;
